import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { Clock, Frown, Pill, RefreshCcw } from 'lucide-react';
const problems = [{
  icon: Clock,
  text: 'Te despiertas a las 3 AM y no puedes volver a dormir, mirando el reloj pasar.'
}, {
  icon: RefreshCcw,
  text: 'Pasas horas dando vueltas en la cama buscando una posición cómoda.'
}, {
  icon: Pill,
  text: 'Los medicamentos te dejan aturdido al día siguiente y no dan descanso real.'
}, {
  icon: Frown,
  text: 'Sientes que el insomnio controla tu vida y te quita energía para disfrutar.'
}];
export function ProblemSection() {
  return <section className="py-24 bg-cream-50" data-id="element-120">
      <div className="container mx-auto px-6" data-id="element-121">
        <FadeIn data-id="element-122">
          <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-123">
            <h2 className="text-3xl md:text-4xl font-bold text-navy-900 mb-6" data-id="element-124">
              ¿Te suena familiar esta situación?
            </h2>
            <p className="text-xl text-navy-700 leading-relaxed" data-id="element-125">
              No estás solo. El sueño cambia después de los 60, pero eso no
              significa que debas resignarte a vivir cansado.
            </p>
          </div>
        </FadeIn>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-126">
          {problems.map((problem, index) => <FadeIn key={index} delay={index * 0.1} data-id="element-127">
              <div className="bg-white p-8 rounded-xl shadow-sm border border-cream-200 h-full hover:shadow-md transition-shadow" data-id="element-128">
                <div className="w-12 h-12 bg-navy-100 rounded-full flex items-center justify-center mb-6 text-navy-900" data-id="element-129">
                  <problem.icon className="w-6 h-6" data-id="element-130" />
                </div>
                <p className="text-lg text-navy-800 font-medium leading-relaxed" data-id="element-131">
                  {problem.text}
                </p>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}